import { createFileRoute } from "@tanstack/react-router";
import { SystemStatusPage } from "@client/components/settings/system-status/system-status-page";

export const Route = createFileRoute("/_app/settings/system-status")({
  component: SystemStatusPage,
});
